
// LP-03 · WhatsApp Automation — variant C "Pick the Job", hero concept 2 "Centred chooser + flow stage".
// Source: 02 - Copy/LP-03-whatsapp-automation-C-copy-v2.md (= C v1 approved + flow-stage node labels).
// Facts, plan cards, form and offer rules are unchanged from v1 (copy v6). Plan cards are word for word
// from onbbits.io/pricing (10 Oct 2026). Edit copy here; components only lay it out.

export const LP_ID = "LP-03"
export const LP_VERSION = "b"
export const OFFER_CODE = "LP03-YEARLY25"
export const CONSENT_TEXT_VERSION = "lp03-v1-2026-10-10"

// Extra 25% off yearly Starter/Pro ends 31 October 2026, 23:59 IST. From 1 Nov the page shows
// its offer-ended state (offer bar and offer lines hidden, CTAs switch to the demo wording).
export const OFFER_END = new Date("2026-11-30T23:59:59+05:30")

// ---- The four jobs (copy "The four jobs") ----
export const JOB_IDS = ["reply", "qualify", "followup", "track"]

export const jobs = {
  reply: {
    id: "reply",
    label: "Reply to every enquiry",
    short: "Reply",
    helper: "Answers in seconds, day or night",
    underCta: "…and see it reply to you on WhatsApp",
    stageHead: ["Every enquiry gets an answer", "in seconds."],
    useHead: ["Instant replies,", "whatever your business sells."],
    flow: [
      { title: "Enquiry arrives", note: "\"Site visit kab ho sakti hai?\"" },
      { title: "Instant reply", note: "Your flow answers in seconds" },
      { title: "Options as buttons", note: "2BHK · 3BHK · Send price list" },
      { title: "Lead stays warm", note: "While your team is busy or asleep" },
    ],
    featureTitle: "Flows that work 24/7.",
    featureText:
      "Your flow replies, answers the usual questions and keeps the lead warm while your team is busy or asleep. Start from a ready-made industry flow in the Flow Library.",
    tag: "Starter: 1 chatbot flow · Pro: 5 chatbot flows",
    quote: 2,
    quoteLead: "What an instant, automated answer did for one store:",
    pricingLine: "Chatbot flows: 1 on Starter, 5 on Pro. The Free plan has no flows.",
    pricingMatch: ["Chat-bot Flow"],
    demoAccent: "Then watch it reply to you.",
    waLine: "First job: Reply to every enquiry.",
    confirmLine: "Ask the flow about replying to every enquiry when it messages you.",
    finalLead: "Start with instant replies.",
    faqOrder: [1, 4, 3, 7, 8, 5, 6, 9, 10],
  },
  qualify: {
    id: "qualify",
    label: "Qualify leads for sales",
    short: "Qualify",
    helper: "Asks your questions before sales steps in",
    underCta: "…and see it qualify you on WhatsApp",
    stageHead: ["Sales only meets leads", "that are ready."],
    useHead: ["Leads qualified before sales calls,", "in any industry."],
    flow: [
      { title: "New lead", note: "Messages your number" },
      { title: "Qualifying questions", note: "Asked with buttons" },
      { title: "WhatsApp Form", note: "Budget, location, visit date" },
      { title: "Agent takes over", note: "From the Team Inbox" },
    ],
    featureTitle: "Acts like your sales assistant.",
    featureText:
      "Your flow asks the questions sales would ask first, with buttons and WhatsApp Forms. When a chat needs a person, your agent steps in from the Team Inbox and the customer never notices a handoff.",
    tag: "Starter: 1 form · Pro: 20 forms · Shared Inbox on Starter · Agent Transfer & Manager Monitoring on Pro",
    quote: 1,
    quoteLead: "What qualifying leads automatically did for one service business:",
    pricingLine: "WhatsApp forms: 1 on Starter, 20 on Pro. Agent Transfer & Manager Monitoring on Pro.",
    pricingMatch: ["WhatsApp form", "Agent Transfer", "Shared Inbox"],
    demoAccent: "Then watch it qualify you.",
    waLine: "First job: Qualify leads for sales.",
    confirmLine: "Ask the flow about qualifying leads for sales when it messages you.",
    finalLead: "Start with qualified leads.",
    faqOrder: [2, 3, 4, 7, 8, 5, 6, 9, 10],
  },
  followup: {
    id: "followup",
    label: "Follow up on time",
    short: "Follow up",
    helper: "Reminders go out even if your team forgets",
    underCta: "…and see how follow-ups land on WhatsApp",
    stageHead: ["Every promised follow-up", "goes out on time."],
    useHead: ["Every promised follow-up,", "sent on time."],
    flow: [
      { title: "A promise in the chat", note: "\"We'll call you on Monday\"" },
      { title: "Reminder set", note: "From the chat, in one click" },
      { title: "Sent on time", note: "Mon, 10:00 AM" },
      { title: "Lead hears back", note: "Even if your team forgets" },
    ],
    featureTitle: "Scheduled reminders.",
    featureText: "Promised to call back on Monday? Schedule it from the chat. Onbbits sends it on time, even if your team forgets.",
    tag: "Starter: 5 reminders/day · Pro: 50 reminders/day",
    quote: 0,
    quoteLead: "What a structured lead process did for one retailer:",
    pricingLine: "Reminder messages: 5 a day on Starter, 50 a day on Pro.",
    pricingMatch: ["reminder messages"],
    demoAccent: "Then watch it follow up with you.",
    waLine: "First job: Follow up on time.",
    confirmLine: "Ask the flow about following up on time when it messages you.",
    finalLead: "Start with follow-ups that go out on time.",
    faqOrder: [11, 1, 4, 7, 8, 5, 6, 9, 10],
  },
  track: {
    id: "track",
    label: "Track every lead",
    short: "Track",
    helper: "Status and notes next to every chat",
    underCta: "…and see your own lead card after the demo chat",
    stageHead: ["Every lead has a status", "and a note."],
    useHead: ["Every lead tracked,", "from first message to sale."],
    flow: [
      { title: "Lead from the chat", note: "Saved automatically" },
      { title: "Status set", note: "New → Interested → Ready to buy" },
      { title: "Note added", note: "Right next to the chat" },
      { title: "Team sees who's ready", note: "No separate spreadsheet" },
    ],
    featureTitle: "Track every lead in a built-in CRM.",
    featureText: "Every lead gets a status and notes, right next to the chat. See who's new, who's interested and who's ready to buy.",
    tag: "On every plan, including Free",
    quote: 0,
    quoteLead: "What a structured lead process did for one retailer:",
    pricingLine: "Lead status and notes are on every plan, including Free.",
    pricingMatch: [],
    demoAccent: "Then watch it track you as a lead.",
    waLine: "First job: Track every lead.",
    confirmLine: "Ask the flow about tracking every lead when it messages you.",
    finalLead: "Start with every lead tracked.",
    faqOrder: [12, 2, 3, 7, 8, 5, 6, 9, 10],
  },
}

// ---- §2 use cases by industry (copy C v4): 10 industries (Arpit, 20 Oct), each with one card per job,
// shown as a horizontal carousel. Illustrations of what a flow can do; no customer names, no real-customer
// claims, no booking inside WhatsApp, no live data from other systems.

const STATUSES = ["New", "Interested", "Ready to buy", "Won"]
const QUALIFIED = { kind: "chip", text: "Lead qualified · handed to sales" }

export const industries = [
  {
    industry: "Real Estate",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Site visit kab ho sakti hai?", time: "11:42 PM" },
          { kind: "out", text: "Hi! Thanks for asking. Which project are you looking at?", buttons: ["2BHK", "3BHK", "Send price list"] },
        ],
        outcome: "Answered at midnight, lead kept warm for the morning.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Help us find the right home", rows: [["Budget", "₹60–80 lakh"], ["Location", "Vesu"], ["Visit", "This weekend"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Sales calls only buyers with a budget and a visit date.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Mon, 10:00 AM", text: "Hi, as promised, here's the brochure for the 2BHK. Shall our team call you today?", state: "Scheduled" }],
        outcome: "The Monday call-back goes out, even on a busy Monday.",
      },
      track: {
        widgets: [{ kind: "lead", title: "2BHK enquiry · Vesu", statuses: STATUSES, active: "Ready to buy", note: "Wants the brochure and a site visit on Saturday." }],
        outcome: "Everyone sees who's ready for a site visit.",
      },
    },
  },
  {
    industry: "Healthcare Clinics",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Is the doctor available tomorrow?", time: "9:15 PM" },
          { kind: "out", text: "Hi! Which department do you need?", buttons: ["Dental", "Skin", "General"] },
        ],
        outcome: "Every patient enquiry gets a reply, even after the front desk closes.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Help us guide you", rows: [["Concern", "Tooth pain"], ["Since", "3 days"], ["Preferred time", "Evening"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "The front desk calls back already knowing the concern.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Tue, 6:00 PM", text: "Hi, just a reminder about your clinic visit tomorrow at 11 AM. Reply here if you need to change the time.", state: "Scheduled" }],
        outcome: "Patients are reminded without anyone picking up the phone.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Dental enquiry", statuses: STATUSES, active: "Interested", note: "Asked about root canal cost. Call after 5 PM." }],
        outcome: "The front desk knows every patient's next step.",
      },
    },
  },
  {
    industry: "Education & Coaching",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Fees and batch timings?", time: "8:40 PM" },
          { kind: "out", text: "Hi! Which course are you interested in?", buttons: ["JEE", "NEET", "Foundation"] },
        ],
        outcome: "Parents get course options in seconds, not the next day.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Find the right batch", rows: [["Class", "11"], ["Course", "NEET"], ["Mode", "Offline"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Counsellors call only students who fit a batch.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Fri, 7:00 PM", text: "Your free demo class is tomorrow at 10 AM. See you there!", state: "Scheduled" }],
        outcome: "Every student gets a reminder before the demo class.",
      },
      track: {
        widgets: [{ kind: "lead", title: "NEET batch enquiry", statuses: STATUSES, active: "Interested", note: "Parent wants a call on Sunday about fees." }],
        outcome: "Counsellors see which parents to call back.",
      },
    },
  },
  {
    industry: "Study Abroad & Visa Consultants",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Canada study visa process?", time: "10:20 PM" },
          { kind: "out", text: "Hi! Which intake are you planning for?", buttons: ["Jan 2027", "Sep 2027", "Not sure"] },
        ],
        outcome: "Students get an answer while they're still comparing consultants.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Plan your study abroad", rows: [["Country", "Canada"], ["Course", "Masters"], ["IELTS", "7.0"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Counsellors spend their time on profiles that are ready.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Wed, 5:00 PM", text: "Hi, did you get a chance to check the document list we sent? Our counsellor can help.", state: "Scheduled" }],
        outcome: "No student goes quiet after the first counselling call.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Canada · Masters enquiry", statuses: STATUSES, active: "Ready to buy", note: "IELTS done. Wants help with the SOP." }],
        outcome: "Every student's stage is clear to the whole team.",
      },
    },
  },
  {
    industry: "Textile & Apparel",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Wholesale rate for sarees?", time: "9:50 PM" },
          { kind: "out", text: "Hi! Which range are you looking for?", buttons: ["Cotton", "Silk", "Send price list"] },
        ],
        outcome: "Retailers get the rate list without waiting for a call.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Your bulk order", rows: [["Product", "Cotton kurtis"], ["Quantity", "200 pcs"], ["City", "Jaipur"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Sales knows the order size before calling.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Thu, 12:00 PM", text: "Hi, as promised, here are the photos of the festive range. Shall we keep a set aside for you?", state: "Scheduled" }],
        outcome: "Promised photos and samples go out on time.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Bulk kurti order", statuses: STATUSES, active: "Interested", note: "Wants 200 pcs. Asked for a sample first." }],
        outcome: "Every bulk enquiry has a clear next step.",
      },
    },
  },
  {
    industry: "Travel & Tour Operators",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Package for 4 people?", time: "11:05 PM" },
          { kind: "out", text: "Hi! Where would you like to go?", buttons: ["Goa", "Kashmir", "International"] },
        ],
        outcome: "Travellers get options while they're still planning.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Plan your trip", rows: [["Destination", "Kashmir"], ["Travellers", "4"], ["Dates", "10–15 Dec"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Agents quote only for trips with real dates.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Sat, 11:00 AM", text: "Hi, your Kashmir itinerary is ready. Shall our team call to walk you through it?", state: "Scheduled" }],
        outcome: "Every quote gets a follow-up before the traveller looks elsewhere.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Kashmir trip · 4 people", statuses: STATUSES, active: "Ready to buy", note: "Wants a houseboat stay. Send the final quote on Monday." }],
        outcome: "The team sees which trips are close to confirming.",
      },
    },
  },
  {
    industry: "Jewellery",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Bridal set designs?", time: "9:30 PM" },
          { kind: "out", text: "Hi! What are you looking for?", buttons: ["Bridal", "Daily wear", "Visit the store"] },
        ],
        outcome: "Shoppers get a reply even after the showroom closes.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Find the right piece", rows: [["Occasion", "Wedding"], ["Budget", "₹2–3 lakh"], ["Metal", "Gold"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Staff have the right designs ready before the visit.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Tue, 4:00 PM", text: "Hi, as promised, here are more designs in your budget. Would you like to visit this week?", state: "Scheduled" }],
        outcome: "Interested buyers hear back while they're still deciding.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Bridal set enquiry", statuses: STATUSES, active: "Interested", note: "Wedding in January. Prefers temple jewellery." }],
        outcome: "Every buyer's preferences sit right next to the chat.",
      },
    },
  },
  {
    industry: "Interior Design & Furniture",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Modular kitchen ka quote?", time: "10:45 PM" },
          { kind: "out", text: "Hi! What shape is your kitchen?", buttons: ["L-shape", "U-shape", "Not sure"] },
        ],
        outcome: "Every quote request gets an instant first answer.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Tell us about your home", rows: [["Home", "3BHK flat"], ["Work", "Kitchen + wardrobes"], ["Start", "Next month"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Designers walk into every call knowing the scope.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Fri, 10:00 AM", text: "Hi, here's the design we discussed. Shall our designer call you to finalise it?", state: "Scheduled" }],
        outcome: "Designs and quotes are followed up without a sticky note.",
      },
      track: {
        widgets: [{ kind: "lead", title: "3BHK interiors enquiry", statuses: STATUSES, active: "Ready to buy", note: "Approved the kitchen design. Wants wardrobe options." }],
        outcome: "Every project's stage is visible to the team.",
      },
    },
  },
  {
    industry: "Automobile Dealerships",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Test drive this Saturday?", time: "8:15 PM" },
          { kind: "out", text: "Hi! Which model are you interested in?", buttons: ["Hatchback", "SUV", "Sedan"] },
        ],
        outcome: "Car buyers get a reply on the weekend too.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Find the right car", rows: [["Model", "Compact SUV"], ["Budget", "₹10–12 lakh"], ["Test drive", "Saturday"]], state: "Submitted" },
          { kind: "agent", text: "Agent view · sales took over the chat" },
        ],
        outcome: "Showroom staff pick up only ready-to-drive leads.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Mon, 6:00 PM", text: "Hi, thanks for the test drive. Shall our team share the on-road price?", state: "Scheduled" }],
        outcome: "Every test drive gets a follow-up, right on time.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Compact SUV enquiry", statuses: STATUSES, active: "Interested", note: "Test drive done. Comparing finance options." }],
        outcome: "Sales sees who's close to buying.",
      },
    },
  },
  {
    industry: "Manufacturing & B2B Suppliers",
    cases: {
      reply: {
        widgets: [
          { kind: "in", text: "Dealer price list bhejo", time: "7:55 PM" },
          { kind: "out", text: "Hi! Which product category?", buttons: ["Pipes", "Fittings", "Valves"] },
        ],
        outcome: "Dealers get a reply without waiting for the sales team.",
      },
      qualify: {
        widgets: [
          { kind: "form", title: "Your requirement", rows: [["Product", "PVC pipes"], ["Quantity", "500 units"], ["Delivery", "Ahmedabad"]], state: "Submitted" },
          QUALIFIED,
        ],
        outcome: "Sales quotes only real, sized requirements.",
      },
      followup: {
        widgets: [{ kind: "reminder", title: "Reminder · Tue, 11:00 AM", text: "Following up on the quote we sent on Friday. Any questions we can answer?", state: "Scheduled" }],
        outcome: "No quote is left without a follow-up.",
      },
      track: {
        widgets: [{ kind: "lead", title: "Dealer enquiry", statuses: STATUSES, active: "New", note: "Wants the price list for 500 units." }],
        outcome: "Dealer leads are sorted without a separate spreadsheet.",
      },
    },
  },
]

/** Cards for one job: all 10 industries. */
export const casesForJob = (job) =>
  industries.map((i) => ({ industry: i.industry, ...i.cases[job] }))

/** No job chosen: the 10 industries, cycling through the four jobs so every job shows. */
export const casesMixed = (jobIds) =>
  industries.map((i, n) => {
    const job = jobIds[n % jobIds.length]
    return { industry: i.industry, ...i.cases[job], job }
  })

export const useCaseCopy = {
  eyebrow: "Use cases by industry",
  prev: "Previous use cases",
  next: "More use cases",
  swipe: "Swipe for more industries",
}

export const noneJob = {
  stageHead: ["All four jobs,", "one WhatsApp number."],
  useHead: ["One WhatsApp number,", "four jobs done for you."],
  flow: [
    { title: "Reply", note: "To every enquiry, in seconds" },
    { title: "Qualify", note: "Before sales steps in" },
    { title: "Follow up", note: "On time, every time" },
    { title: "Track", note: "Status and notes" },
  ],
  underCta: "…and see Onbbits reply to you on WhatsApp",
  quote: 0,
  quoteLead: "What a structured lead process did for one retailer:",
  demoAccent: "Then watch it work on your WhatsApp.",
  finalLead: "Your next enquiry is on its way.",
  finalAccent: "Let Onbbits handle it.",
  faqOrder: [1, 2, 11, 12, 7, 8, 3, 4, 5, 6, 9, 10],
}

/** ?job= wins; else ag2 → qualify, ag3 → reply; else none. */
export const jobByAdGroup = { ag2: "qualify", ag3: "reply" }

export const meta = {
  title: "WhatsApp Automation Tool for Business | Onbbits",
}

// H1 swaps by utm_content (Google Ads ad group). The part after "/" is muted (two-tone).
export const h1ByAdGroup = {
  ag1: ["What should your WhatsApp automation", "do first?"],
  ag2: ["What should your WhatsApp chatbot for business", "do first?"],
  ag3: ["What should your WhatsApp auto reply", "do first?"],
}

export const offerBar = {
  text: "Extra 25% off yearly Starter & Pro",
  textShort: "Extra 25% off yearly",
  claimBy: "Claim by 30 Nov",
  link: "Claim it",
}

export const hero = {
  eyebrow: "WhatsApp automation tool for business",
  sub: "Onbbits replies to enquiries, qualifies leads, follows up and tracks every lead on WhatsApp. Pick one to see how, then watch it work on your own phone.",
  chooserLabel: "Choose a job",
  showAll: "Not sure? Show me everything",
  cta: "Book a Free Demo",
  ctaEnded: "Book a Free Demo",
  ctaShort: "Book a Free Demo",
  offerHighlight: "Includes an extra 25% off yearly plans",
  termsLink: "See terms",
  credentials: ["Official WhatsApp Business API", "Meta Tech Provider", "Live in 30 minutes", "No setup fees"],
  stageLabel: "How it works",
}

export const entry = {
  eyebrow: "One platform",
  h2Lead: "Start with one job.",
  h2Accent: "Onbbits does the other three too.",
  link: "See this job",
}

// ---- Real proof (07 - Knowledge Base/Onbbits-Proof-Inventory.md §1–2; live on onbbits.io, 20 Oct 2026).
// Quotes are verbatim except brand casing ("ONBBITS" → "Onbbits"). Logo files are onbbits.io build
// assets: copy them into /public/clients/ before launch (their hashed names change on redeploy).

export const clientLogos = [
  { name: "Shethiya Telecom", src: `/Images/shethiya.svg` },
  { name: "Kalyan Integrated Care & Research Center", src: `/Images/kalyan-integrated-cure.svg` },
  { name: "Deeka Fix LLP", src: `/Images/dekaa-logo.svg` },
  { name: "Two Rabbits", src: `/Images/two-rabbits.svg` },
]

export const logoStripLabel = "Trusted by growing businesses"

export const quotes = {
  items: [
    {
      metric: "3.5x",
      label: "Faster Lead Capture",
      quote: "Managing incoming customer leads across channels used to be chaotic. Onbbits structured our whole process, allowing us to route inquiries instantly and never miss a follow-up.",
      name: "Kalpesh Shethiya",
      role: "Owner, Shethiya Telecom",
      logo: clientLogos[0].src,
    },
    {
      metric: "50%+",
      label: "Higher Lead Conversion",
      quote: "Automating our lead pipeline boosted our operational efficiency. Tracking, qualifying, and assigning service requests is now effortless.",
      name: "Ankur Bavarava",
      role: "Founder, Deeka Fix LLP",
      logo: clientLogos[2].src,
    },
    {
      metric: "2.4x",
      label: "E-Commerce Sales Growth",
      quote: "Onbbits streamlined our store sales and customer chats. Automated product queries to direct purchases made scaling seamless",
      name: "Nitin Vekariya",
      role: "Founder, The Buzz Brew",
    },
  ],
  footnote: "Customer-reported results, as published on onbbits.io.",
}

export const quoteCopy = { more: "See the other stories", less: "Show one story" }

// ---- Pricing (word for word from onbbits.io/pricing) ----
export const pricing = {
  eyebrow: "Pricing · Yearly offer",
  h2Lead: "Extra 25% off",
  h2Accent: "every yearly plan.",
  sub: "Pick a yearly plan and fill the form below. We'll send your coupon code on WhatsApp.",
  // Shown after the offer ends
  endedEyebrow: "Pricing",
  endedH2Lead: "Simple, transparent pricing",
  endedH2Accent: "for every business",
  endedSub: "Pick the plan that fits your team. We'll help you choose on your demo call.",
  endedLine: "The extra 25% yearly offer ended on 31 Oct 2026.",
  toggle: [
    ["monthly", "Monthly"],
    ["quarterly", "Quarterly"],
    ["yearly", "Yearly"],
  ],
  yearlyBadge: "Extra 25% off",
  switchToYearly: "Switch to yearly for an extra 25% off",
  offerTag: "Extra 25% off",
  gstLine: "18% GST will be applicable.",
  ratesTitle: "WhatsApp Conversation Charges (per message)",
  rates: [
    ["Marketing", "₹0.95"],
    ["Utility", "₹0.127"],
    ["Authentication", "₹0.127"],
    ["Service", "₹0.127"],
  ],
  ratesFree: "1,000 free Service Messages/month",
  below: "Meta's messaging fees are separate. We'll explain exactly what to expect on the demo call.",
  terms:
    "Extra 25% off the yearly price of Starter and Pro plans, for the first year, for businesses that claim it through this page and sign up by 30 Nov 2026. + 18% GST. Meta messaging charges are separate. Can't be combined with other offers.",
  moreLabel: "See all features",
  lessLabel: "Show fewer features",
  plans: [
    {
      id: "free",
      name: "Free Forever",
      tagline: "Start automating your first conversations at no cost.",
      button: "Get Started for Free",
      gst: false,
      prices: {
        monthly: { price: "₹0", per: "/mo", note: "No credit card required" },
        quarterly: { price: "₹0", per: "/mo", note: "No credit card required" },
        yearly: { price: "₹0", per: "/mo", note: "No credit card required" },
      },
      features: [
        "Manage conversations with an owner account",
        "Manage up to 50 MB of asset storage",
        "Create up to 3 templates",
        "Up to 3 tags",
        "Basic Support",
        "Live Chat Dashboard",
      ],
    },
    {
      id: "starter",
      name: "Starter",
      tagline: "For small businesses ready to automate WhatsApp.",
      button: "Book a Free Demo",
      gst: true,
      prices: {
        monthly: { price: "₹1,399", per: "/mo", note: "Billed monthly" },
        quarterly: { price: "₹1,299", per: "/mo", note: "Billed ₹3,897 · save 7.15%" },
        yearly: { price: "₹1,199", per: "/mo", note: "Billed ₹14,388 yearly" },
      },
      offer: { price: "₹899", billed: "Billed ₹10,791 yearly", save: "You save ₹3,597 more", button: "Claim 25% off Starter", value: 10791 },
      featuresHeading: "Everything in Free, plus —",
      features: [
        "1 Owner + 3 FREE Agents Included",
        "Create up to 100 Templates",
        "Manage Conversations with 50 Tags",
        "Manage up to 1 GB of Asset Storage",
        "Up to 2 Custom Attributes",
        "1 Chat-bot Flow Included",
        "Multi Agent Access",
        "Run Broadcasts Seamlessly",
        "Shared Inbox for Team Collaboration",
        "Plan and Automate your Campaigns",
        "Get Analytics, Reporting & Conversion Insights",
        "CSV Campaign Scheduler",
        "Priority Ticket-based Assistance",
        "Seamless API Access",
        "Launch API requests 250 per minute",
        "Create and use 1 WhatsApp form",
        "Draft your template content using AI (up to 25 generations included)",
        "Schedule up to 5 reminder messages per day",
      ],
    },
    {
      id: "pro",
      name: "Pro",
      tagline: "For growing teams that need full automation at scale.",
      button: "Book a Free Demo",
      gst: true,
      highlighted: true,
      prices: {
        monthly: { price: "₹3,499", per: "/mo", note: "Billed monthly" },
        quarterly: { price: "₹3,249", per: "/mo", note: "Billed ₹9,747 · save 7.14%" },
        yearly: { price: "₹2,999", per: "/mo", note: "Billed ₹35,988 yearly" },
      },
      offer: { price: "₹2,249", billed: "Billed ₹26,991 yearly", save: "You save ₹8,997 more", button: "Claim 25% off Pro", value: 26991 },
      featuresHeading: "Everything in Starter, plus —",
      features: [
        "1 Owner + 20 FREE Agents Included",
        "Create up to 1000 Templates",
        "Manage Conversations with 200 Tags",
        "Manage up to 5 GB of Asset Storage",
        "Smart Segmentation with 15 Custom Attributes",
        "5 Chat-bot Flow Available",
        "Agent Transfer & Manager Monitoring",
        "Seamless API Access",
        "Launch API requests 500 per minute",
        "Faster Response Support Assistant",
        "Create and use 20 WhatsApp forms.",
        "Create up to 25 audience segments.",
        "Draft your template content using AI (up to 100 generations included)",
        "Schedule up to 50 reminder messages per day",
        "Create product Templates",
        "Design carousel(swipeable) messages",
        "Manage products, catalogs, and Orders",
      ],
    },
    {
      id: "enterprise",
      name: "Enterprise",
      tagline: "For agencies and large teams with custom requirements.",
      button: "Book a Free Demo",
      gst: true,
      prices: {
        monthly: { price: "Let's Talk", note: "Annual contract · volume pricing" },
        quarterly: { price: "Let's Talk", note: "Annual contract · volume pricing" },
        yearly: { price: "Let's Talk", note: "Annual contract · volume pricing" },
      },
      featuresHeading: "Everything in Pro, plus —",
      features: [
        "Scale Effortlessly with Flexible Team Sizes",
        "Unlock Custom Templates, Tags & Attributes",
        "Tailored Storage Capacity",
        "Automate Campaigns and Retarget Customers.",
        "Dedicated and Premium Support.",
        "Custom Chatbot Flow Limits",
        "Custom API Limits Tailored for High Volume Campaigns.",
      ],
    },
  ],
}

export const demo = {
  eyebrow: "Free demo · extra 25% off",
  h2Lead: "Book your free demo.",
  body: "Fill this in to book your free demo and claim your extra 25% off a yearly plan. WhatsApp opens straight away: our flow messages you within seconds, asks a few questions, and our team confirms your demo time. It's the same kind of automation we'll build for your business.",
  stepsTitle: "What happens next",
  steps: [
    ["Fill the form.", "About a minute. Your demo request and your 25% off are in."],
    ["WhatsApp opens.", "Our flow messages you within seconds, day or night."],
    ["Demo call.", "Our team confirms a time and builds your first flow live on the call. Use your coupon when you sign up."],
  ],
  // Offer-ended wording
  endedEyebrow: "Live demo",
  endedH2Lead: "Don't take our word for it.",
  endedH2Accent: "Watch it work on your WhatsApp.",
  endedBody: "Fill this in and WhatsApp opens straight away. Our flow messages you within seconds, asks a few questions, and our team confirms your demo time. It's the same kind of automation we'll build for your business.",
  endedStep1: "About a minute.",
  endedStep3: "Our team confirms a time and builds your first flow live on the call.",
  preferCall: "Prefer a call?",
}

export const form = {
  heading: "Book your free demo",
  headingEnded: "See it work on your WhatsApp",
  sub: "Takes a minute. WhatsApp opens as soon as you submit.",
  offerIncluded: "Your extra 25% off yearly Starter & Pro is included.",
  steps: ["About you", "Your business"],
  continue: "Continue",
  back: "Back",
  submit: "Book a Free Demo",
  submitEnded: "Book a Free Demo",
  submitting: "Sending…",
  underButton: "WhatsApp opens the moment you submit. No payment on this page. Live in 30 minutes · No setup fees.",
  trustLine: "Official WhatsApp Business API · Meta Tech Provider · Follows Meta's messaging rules",
  offerTermsShort: "Extra 25% off Starter & Pro yearly, first year only.",
  termsLink: "Offer terms",
  errorPrefix: "Please complete:",
  networkError: "We couldn't send your details. Please try again, or call us.",
  phoneHelp: "Our flow will message this number.",
  metaHelp: "Not sure? Pick No. We'll help you set it up.",
  planLegend: "Which yearly plan?",
  planOptions: [
    ["starter", "Starter"],
    ["pro", "Pro"],
    ["unsure", "Not sure yet"],
  ],
  consent:
    "I agree that Onbbits Innovation Pvt. Ltd. may contact me on WhatsApp and phone about this enquiry and process the details above for that purpose, as per the Privacy Policy. I can withdraw consent anytime by replying STOP or writing to info@onbbits.io.",
  optIn: "Send me product updates on WhatsApp",
  businessTypes: [
    "Healthcare & clinics",
    "Real estate",
    "Interiors & home",
    "E-commerce, D2C & retail",
    "Banking, finance & insurance",
    "Restaurants & F&B",
    "Automobile",
    "Salons & spa",
    "Education & coaching",
    "Events & webinars",
    "Travel & hospitality",
    "Manufacturing & B2B",
    "IT services & agencies",
    "Other",
  ],
  enquiryOptions: ["Under 50", "50–300", "300+"],
  // Pre-filled WhatsApp message
  waText: (name, business, type, offer, jobLine) =>
    `Hi, I'm ${name} from ${business} (${type}). ${offer ? "I'd like the 25% yearly offer and the live demo." : "Show me the live demo."}${jobLine ? ` ${jobLine}` : ""}`,
  jobChip: "Your first job:",
  jobChange: "Change",
  jobNone: "Not decided",
  done: {
    heading: "Your demo request is in. WhatsApp is opening…",
    headingEnded: "WhatsApp is opening…",
    body: (first) => `Our flow is messaging you now, ${first}. Reply there to see the automation in action.`,
    offerLine: "Your coupon code for the extra 25% off comes on WhatsApp. Use it when you sign up for a yearly Starter or Pro plan by 30 Nov.",
    button: "Didn't open? Tap here",
    edit: "Edit my details",
  },
}

export const integrations = {
  label: "Works with",
  chips: ["ERPNext", "Google Contacts", "Google Sheets", "WooCommerce", "Razorpay", "WordPress", "Pabbly", "API Integration"],
  line: "Need something else? Through Pabbly and our API, Onbbits connects with almost any tool, including Salesforce and HubSpot.",
}

export const faq = {
  eyebrow: "Common questions",
  h2: "Frequently asked questions.",
  // Numbered 1–12 as in the copy file; the order on the page follows the chosen job.
  items: {
    1: ["Does WhatsApp automation work at night and on weekends?", "Yes. Your flows run 24/7 and reply in seconds, whether your team is online or not."],
    2: ["How does Onbbits qualify a lead?", "Your flow asks the questions your sales team would ask first, like budget, location or date, using buttons and WhatsApp Forms. Answers are saved to the lead's profile, so your team sees who's ready to buy."],
    3: ["Can my team take over a chat from the bot?", "Anytime. An agent steps in from the Team Inbox and the customer never notices a handoff."],
    4: ["Which Onbbits plan includes chatbot flows?", "Starter includes 1 Chat-bot Flow and Pro includes 5. Enterprise gets custom limits. The Free plan has no flows."],
    5: ["What do I need to go live?", "Live in 30 minutes once your GST, website and Meta Business Portfolio are ready. Our team does the setup."],
    6: ["Do you build the first flow for me?", "Yes. We build your first automation flow live on the demo call, and there are no setup fees."],
    7: ["How much does WhatsApp automation cost?", "With the extra 25% off on a yearly plan claimed through this page, Starter is ₹899/mo (billed ₹10,791) and Pro is ₹2,249/mo (billed ₹26,991), + 18% GST. Standard yearly prices are ₹1,199/mo and ₹2,999/mo; monthly and quarterly options are on the pricing toggle above. Meta's messaging fees are separate. A Free Forever plan is also available, without chatbot flows."],
    8: ["Will my WhatsApp number get blocked?", "Onbbits runs on the official WhatsApp Business API as a Meta Tech Provider and follows Meta's messaging rules."],
    9: ["Does Onbbits work for my type of business?", "Any business that gets enquiries on WhatsApp: clinics, real estate, interiors, retail and D2C, automobile, salons, education, travel, B2B and more."],
    10: ["How do I get the extra 25% off?", "Fill the form on this page, then choose a yearly Starter or Pro plan when you sign up. We send you a coupon code on WhatsApp; use it when you sign up. It applies to the first year of yearly billing, not to monthly or quarterly plans, and can't be combined with other offers."],
    11: ["Can Onbbits send follow-up reminders automatically?", "Yes. Schedule a reminder from the chat in one click and Onbbits sends it at the time you chose. Starter includes 5 reminder messages a day and Pro includes 50."],
    12: ["Does Onbbits have a CRM for WhatsApp leads?", "Yes, a basic one. Every lead gets a status and notes, right next to the chat, so you can see who's new, who's interested and who's ready to buy. It's on every plan, including Free."],
  },
  // After the offer ends: FAQ 7 loses the offer prices and FAQ 10 is hidden.
  costEnded:
    "Starter starts at ₹1,199/mo and Pro at ₹2,999/mo, billed yearly, + 18% GST. Monthly and quarterly options are on the pricing toggle above. Meta's messaging fees are separate. A Free Forever plan is also available, without chatbot flows.",
}

export const finalCta = {
  accent: "Add the rest when you're ready.",
  under: ["Live in 30 minutes", "No setup fees"],
  underEnded: ["Live in 30 minutes", "No setup fees"],
}

export const footerNote = "Reply STOP on WhatsApp anytime to stop messages."
